import React from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import AboutUs from "../sections/agriculture/about-us";
import Address from "../sections/agriculture/address";
import DatesGrower from "../sections/agriculture/dates-grower";
import FairTradeQuality from "../sections/agriculture/fair-trade-quality";
import AgricultureHeader from "../sections/agriculture/header";
import KingOfDates from "../sections/agriculture/king-of-dates";
import OurBrands from "../sections/agriculture/our-brands";
import PackagingOption from "../sections/agriculture/packaging-option";
import ProductRange from "../sections/agriculture/product-range";
import Team from "../sections/agriculture/team";

import { Helmet } from "react-helmet";
import SubscribeContact from "../components/subscribeContact";
import TableOfContents from "../components/table-of-contents";
import { agricultureSubMenus } from "../data/agriculture-sub-menu";
import { useScrollTop } from "../hook/useScrollTop";
import agricultureBanner from "../images/agriculture/agriculture-banner.webp";
import segamBannerImageLogo from "../images/agriculture/segram-banner-logo.webp";

const Agriculture = () => {
  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Agriculture</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={agricultureBanner}>
        <div className="text-center mt-9">
          <img
            src={segamBannerImageLogo}
            className="agriculture-address-img"
            alt="segam banner logo"
          />
        </div>
      </Header>
      <section className="d-none d-md-block position-sticky top-0 w-100">
        <ul className="d-flex justify-content-around fs-14 text-center p-0 m-0 align-items-stretch">
          {agricultureSubMenus.map((menu, index) => (
            <li
              key={index}
              className="list-style-none submenu-link border-gray w-100 d-flex align-items-center justify-content-center"
            >
              <a
                href={menu.link}
                className="text-decoration-none gilroy-bold d-block py-3"
              >
                {menu.label}
              </a>
            </li>
          ))}
        </ul>
      </section>
      <TableOfContents routes={agricultureSubMenus} />
      <AgricultureHeader />
      <AboutUs />
      <ProductRange />
      <Team />
      <DatesGrower />
      <KingOfDates />
      <FairTradeQuality />
      <PackagingOption />
      <OurBrands />
      <Address />
      <SubscribeContact />
      <Footer />
    </>
  );
};

export default Agriculture;
